(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmLocationDeleteController',AppraisalFirmLocationDeleteController);

    AppraisalFirmLocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraisalFirmLocation'];

    function AppraisalFirmLocationDeleteController($uibModalInstance, entity, AppraisalFirmLocation) {
        var vm = this;

        vm.appraisalFirmLocation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraisalFirmLocation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
